import { render } from "./Date.vue?vue&type=template&id=225fecbe&scoped=true"
import script from "./Date.vue?vue&type=script&lang=js"
export * from "./Date.vue?vue&type=script&lang=js"

import "./Date.vue?vue&type=style&index=0&id=225fecbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225fecbe"]])

export default __exports__